import {
  Button,
  Divider,
  Text,
} from '@chakra-ui/react'
import { Insurer } from 'BrokerTsLib/src/enums'
import { Link } from 'react-router-dom'

import { usePartner } from '@/context/PartnerContext'
import { useApp } from '@/hooks/useApp'

import { Apps, getAppString } from '@/dtos'
import { DropdownMenuItem } from './MenuItem'

export const Information = () => {
  const { lastApp } = useApp()
  const { currentPartner } = usePartner()
  const partner = currentPartner?.partner

  if (partner !== 'Jap' && partner !== 'Essox')
    return null

  let appString = getAppString(lastApp?.app)
  if (lastApp?.app == Apps.extra || lastApp?.app == Apps.shortInsurance) {
    appString = getAppString(Apps.vehicle)
  }

  return <DropdownMenuItem label='Informace'>
    <Button variant="ghost" as={Link} to={appString ? `/${appString}/news` : '/news'}>Aktuality, informace</Button>
    {appString && <>
      {partner === 'Jap' && <JapSection app={appString} />}
      {partner === 'Essox' &&
        <Button variant="ghost" as={Link} to={`/${appString}/WorkGuidelines`}>Pracovní směrnice</Button>}
    </>}
  </DropdownMenuItem>
}

const JapSection = ({ app }: { app: string }) => {
  return <>
    <Button variant="ghost" as={Link} to={`/${app}/Documents`}>Dokumenty ke stažení</Button>
    <Divider my={2} />
    <Text textAlign='center' fontSize='sm' fontWeight='semibold'>Pojišťovny</Text>
    <Button variant="ghost" as={Link} to={`/${app}/insurer/${Insurer.Allianz}`}>Allianz</Button>
    <Button variant="ghost" as={Link} to={`/${app}/insurer/${Insurer.Colonnade}`}>Colonnade</Button>
    <Button variant="ghost" as={Link} to={`/${app}/insurer/${Insurer.CPP}`}>ČPP</Button>
    <Button variant="ghost" as={Link} to={`/${app}/insurer/${Insurer.GeneraliCeskaPojistovna}`}>GČP</Button>
    <Button variant="ghost" as={Link} to={`/${app}/insurer/${Insurer.Kooperativa}`}>Kooperativa</Button>
    <Button variant="ghost" as={Link} to={`/${app}/insurer/${Insurer.Uniqa}`}>Uniqa</Button>
  </>
}